import React from "react";

import Form, { formTypes } from "../../Forms/Containers/FormCreator";

import "./citizenPerception.css";

function FilterPerceptionComponent(props) {
  return (
    <>
      <Form
        onChange={props.onChange}
        objectCreator={[
          {
            type: formTypes.div,
            classContainer: "line line-5",
          },

          {
            type: formTypes.title,
            classContainer: "line line-90",
            classLabel: "input-text",
            label: "Filtrar por:",
            variable: "title",
          },
          {
            type: formTypes.div,
            classContainer: "line line-5",
          },
          {
            type: formTypes.div,
            classContainer: "line line-5",
          },
          {
            type: formTypes.select,
            label: "Comuna",
            // placeholder: "Seleccione el tipo de documento",
            required: false,
            classContainer: "line line-30",
            classLabel: "input-text",
            // classInput: "form-control",
            variable: "comuna",
            keyValue: "value",
            keyText: "text",
            data: [
              { value: "-", text: "--Seleccione comuna--" },
              { value: "COMUNA 1", text: "Comuna 1" },
              { value: "COMUNA 2", text: "Comuna 2" },
              { value: "COMUNA 3", text: "Comuna 3" },
              { value: "COMUNA 4", text: "Comuna 4" },
              { value: "COMUNA 5", text: "Comuna 5" },
              { value: "COMUNA 6", text: "Comuna 6" },
              { value: "COMUNA 7", text: "Comuna 7" },
              { value: "COMUNA 8", text: "Comuna 8" },
              { value: "VEREDAS", text: "Veredas" },
            ],
            value: [],
          },
          {
            type: formTypes.select,
            label: "Grupo Etario",
            required: false,
            classContainer: "line line-30",
            classLabel: "input-text",
            variable: "edad",
            keyValue: "value",
            keyText: "text",
            data: [
              {
                value: "-",
                text: "--Seleccione rango etario--",
              },
              { value: "18 AÑOS APROX", text: "18 Años aproximadamente" },
              { value: "19 - 26", text: "19 - 26" },
              { value: "27 - 59", text: "27 - 59" },
              { value: "60 EN ADELANTE", text: "60+" },
              // { value: "N/R", text: "N/R" },
            ],
            value: [],
          },
          {
            type: formTypes.select,
            label: "Género",
            required: false,
            classContainer: "line line-30",
            classLabel: "input-text",
            variable: "genero",
            keyValue: "value",
            keyText: "text",
            data: [
              { value: "-", text: "--Seleccione género--" },
              { value: "Hombre", text: "Masculino" },
              { value: "Mujer", text: "Femenino" },
              { value: "LGTBI", text: "LGTBI" },
              { value: "NS/NR", text: "No reporta" },
            ],
            value: [],
          },
          {
            type: formTypes.div,
            classContainer: "line line-5",
          },
          {
            type: formTypes.div,
            classContainer: "line line-5",
          },
          {
            type: formTypes.select,
            label: "Ocupación",
            required: false,
            classContainer: "line line-30",
            classLabel: "input-text",
            variable: "ocupacion",
            keyValue: "value",
            keyText: "text",
            data: [
              { value: "-", text: "--Seleccione barrio--" },
              {
                value: "Actividades en el hogar",
                text: "Actividades en el hogar",
              },
              { value: "Trabajar", text: "Trabajador" },
              { value: "Estudiar", text: "Estudiante" },
              { value: "Ni estudia ni trabaja", text: "Ni estudia ni trabaja" },
              { value: "Buscar trabajo", text: "Buscando trabajo" },
              { value: "NS/NR", text: "NS/NR" },
            ],
            value: [],
          },
          {
            type: formTypes.select,
            label: "Nivel educativo",
            required: false,
            classContainer: "line line-30",
            classLabel: "input-text",
            variable: "nivelEducativo",
            keyValue: "value",
            keyText: "text",
            data: [
              {
                value: "-",
                text: "--Seleccione nivel educativo--",
              },
              { value: "PRIMARIA", text: "Primaria" },
              { value: "BACHILLERATO", text: "Bachillerato" },
              { value: "TECNICO", text: "Técnico" },
              { value: "UNIVERSITARIO", text: "Universitario" },
              { value: "Maestria", text: "Maestria" },
              { value: "Especialista", text: "Especialista" },
              { value: "Sin Escolaridad", text: "Sin Escolaridad" },
              { value: "NS/NR", text: "NS/NR" },
            ],
            value: [],
          },
          {
            type: formTypes.select,
            label: "Estrato",
            required: false,
            classContainer: "line line-30",
            classLabel: "input-text",
            variable: "estrato",
            keyValue: "value",
            keyText: "text",
            data: [
              { value: "--SeleccioneEstrato", text: "--Seleccione estrato--" },
              { value: "1", text: "1" },
              { value: "2", text: "2" },
              { value: "3", text: "3" },
              { value: "4", text: "4" },
              { value: "5", text: "5" },
              { value: "6", text: "6" },
            ],
            value: [],
          },

          {
            type: formTypes.div,
            classContainer: "line line-5",
          },
        ]}
      />
    </>
  );
}
export default FilterPerceptionComponent;
